export default (axios, baseURL) => async (clientSid, appClientId, hubConfig) => {
  const url = `/hub/clients/${encodeURIComponent(clientSid)}/hub-config/${encodeURIComponent(appClientId)}`;

  const axiosConfig = {
    method: 'POST',
    baseURL,
    url,
    data: { ...hubConfig }
  };

  const axiosResponse = await axios(axiosConfig);

  if (!axiosResponse || !axiosResponse.data || typeof axiosResponse.data !== 'object') {
    throw new Error('Invalid response from gateway');
  }
  return axiosResponse.data;
};
